import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { TestId } from '../../enums/test';

type Props = {
    className?: string;
    text?: string;
    color?: 'primary' | 'danger';
    size?: 'xs' | 'sm' | 'md' | 'lg';
};

function SpinnerLoader({ className, text, color = 'primary', size = 'lg' }: Props) {
    const colorClassName = {
        primary: 'border-t-blue-500',
        danger: 'border-t-critical-600',
    };

    const sizeClassName = {
        xs: 'w-15 h-15',
        sm: 'w-20 h-20',
        md: 'w-30 h-30',
        lg: 'w-40 h-40',
    }[size];

    return (
        <div className={clsx('flex flex-col gap-10 items-center', className)} data-testid={TestId.SPINNER_LOADER}>
            <div
                className={clsx(
                    'animate-spin border-2 border-charcoal-100 rounded-[50%]',
                    colorClassName[color],
                    sizeClassName,
                )}
            />
            {text && <Typography variant='body-sm'>{text}</Typography>}
        </div>
    );
}

export default SpinnerLoader;
